import { render, staticRenderFns } from "./Nota.vue?vue&type=template&id=51e191ab&"
import script from "./Nota.vue?vue&type=script&lang=js&"
export * from "./Nota.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports